/* istanbul ignore file */
import React from 'react';
import { HtmlField } from 'framework/ui/field';
import { ReplaceUrlWithLink } from 'framework/utils';
import { Box } from '@mui/material';

const FeedbackField = (props: any) => (
  <Box
    sx={{
      whiteSpace: 'pre-line',
      wordBreak: 'break-all',
      display: '-webkit-box',
      WebkitLineClamp: 4,
      WebkitBoxOrient: 'vertical',
      overflowY: 'hidden',
    }}
  >
    <ReplaceUrlWithLink>
      <HtmlField {...props} />
    </ReplaceUrlWithLink>
  </Box>
);

export default FeedbackField;
